import { Suspense, lazy, ElementType } from "react";
// components
import LoadingScreen from "../components/loading-screen";

// ----------------------------------------------------------------------

const Loadable = (Component: ElementType) => (props: any) => (
  <Suspense fallback={<LoadingScreen />}>
    <Component {...props} />
  </Suspense>
);

// ----------------------------------------------------------------------

export const LoginPage = Loadable(
  lazy(() => import("../pages/auth/login/LoginPage"))
);
export const LoginVerifyPage = Loadable(
  lazy(() => import("../pages/auth/login/LoginVerifyPage"))
);
export const ResetPassword = Loadable(
  lazy(() => import("../pages/auth/login/ResetPassword"))
);
export const SetNewPassword = Loadable(
  lazy(() => import("../pages/auth/login/SetNewPassword"))
);

//registration
export const SignUpPage = Loadable(
  lazy(() => import("../pages/auth/registration/SignUpPage"))
);
export const SignUpMobileVerify = Loadable(
  lazy(() => import("../pages/auth/registration/SignUpMobileVerify"))
);
export const SignUpEmailVerify = Loadable(
  lazy(() => import("../pages/auth/registration/SignUpEmailVerify"))
);

// kyc
export const BusinessVerification = Loadable(
  lazy(() => import("../pages/auth/kyc/BusinessVerification"))
);
export const BusinessDocuments = Loadable(
  lazy(() => import("../pages/auth/kyc/BusinessDocuments"))
);
export const DirectorAndPromoter = Loadable(
  lazy(() => import("../pages/auth/kyc/DirectorAndPromoter"))
);
export const DirectorDocuments = Loadable(
  lazy(() => import("../pages/auth/kyc/DirectorDocuments"))
);
export const ApplicationReview = Loadable(
  lazy(() => import("../pages/auth/kyc/ApplicationReview"))
);

//banks
export const BankSelection = Loadable(
  lazy(() => import("../pages/auth/banks/BankSelection"))
);
export const BankSelectionSteps = Loadable(
  lazy(() => import("../pages/auth/banks/BankSelectionSteps"))
);
export const BankOSV = Loadable(
  lazy(() => import("../pages/auth/banks/BankOSV"))
);
export const BankAccountOpen = Loadable(
  lazy(() => import("../pages/auth/banks/BankAccountOpen"))
);
export const BankAccountSetUp = Loadable(
  lazy(() => import("../pages/auth/banks/BankAccountSetUp"))
);
export const WithdrawalBankAccount = Loadable(
  lazy(() => import("../pages/auth/banks/WithdrawalBankAccount"))
);

//Home
export const Home = Loadable(lazy(() => import("../pages/msme/Home/Index")));
export const UploadNewInvoice = Loadable(
  lazy(() => import("../pages/msme/Home/upload-new-invoice/index"))
);

export const MyPayables = Loadable(
  lazy(() => import("../pages/msme/Home/MyPayables/index"))
);
export const MyPayablesDetails = Loadable(
  lazy(() => import("../pages/msme/Home/MyPayables/MyPayablesDetails"))
);
export const PendingPayables = Loadable(
  lazy(() => import("../pages/msme/Home/PendingPayables/index"))
);
export const PendingPayablesDetails = Loadable(
  lazy(
    () => import("../pages/msme/Home/PendingPayables/PendingPayablesDetails")
  )
);
export const PayableDetail = Loadable(
  lazy(() => import("../pages/msme/Home/PendingPayables/PayableDetail/index"))
);
export const MyReceivables = Loadable(
  lazy(() => import("../pages/msme/Home/MyReceivable/index"))
);
export const MyReceivableDetails = Loadable(
  lazy(() => import("../pages/msme/Home/MyReceivable/MyReceivableDetails"))
);
export const PendingReceivables = Loadable(
  lazy(() => import("../pages/msme/Home/PendingReceivable/index"))
);
export const ReceivableDetails = Loadable(
  lazy(() => import("../pages/msme/Home/PendingReceivable/ReceivableDetails"))
);
export const MakingPayment = Loadable(
  lazy(
    () =>
      import(
        "../pages/msme/Home/PendingPayables/PayableDetail/making-payment/index"
      )
  )
);
export const SuccessPayment = Loadable(
  lazy(
    () =>
      import(
        "../pages/msme/Home/PendingPayables/PayableDetail/success-payment/index"
      )
  )
);
export const NewConnections = Loadable(
  lazy(() => import("../pages/msme/Home/new-connections/index"))
);

// Staff accounts
export const AccessControl = Loadable(
  lazy(() => import("../pages/msme/access-control/index"))
);

//reports
export const Reports = Loadable(
  lazy(() => import("../pages/msme/Reports/Index"))
);

//assuredpay invoices
export const AssuredPayBilling = Loadable(
  lazy(() => import("../pages/msme/AssuredPayBilling/Index"))
);

export const BankAccounts = Loadable(
  lazy(() => import("../pages/msme/bank-accounts/index"))
);

export const Chat = Loadable(lazy(() => import("../pages/msme/Chat")));

// mislenious
export const TermsAndCondition = Loadable(
  lazy(() => import("../pages/msme/TermsAndCondition"))
);

export const Profile = Loadable(lazy(() => import("../pages/msme/Profile")));
export const Ticket = Loadable(
  lazy(() => import("../pages/msme/support/TicketManagement"))
);
export const CreateTicket = Loadable(
  lazy(() => import("../pages/msme/support/CreateTicket"))
);

// ********************** AFFILIATE ****************************
export const AffiliateDashboard = Loadable(
  lazy(() => import("../pages/affiliate/affiliate-dashboard/index"))
);
export const AffiliateBankAccounts = Loadable(
  lazy(() => import("../pages/affiliate/affiliate-bank-accounts/index"))
);
export const Invitation = Loadable(
  lazy(() => import("../pages/affiliate/affiliate-invitation/index"))
);
export const Commission = Loadable(
  lazy(() => import("../pages/affiliate/affiliate-commission/index"))
);

// ********************** SALES USER ****************************
export const SalesDashboard = Loadable(
  lazy(() => import("../pages/sales/SalesDashboard"))
);
export const SalesList = Loadable(
  lazy(() => import("../pages/sales/InviteAffiliateUser"))
);
export const Team = Loadable(lazy(() => import("../pages/sales/Team")));
export const Perfomance = Loadable(
  lazy(() => import("../pages/sales/Performance"))
);

// Sales - Profile (includes Bank Management section)
export const SalesProfile = Loadable(
  lazy(() => import("../pages/sales/Profile"))
);

export const Page404 = Loadable(lazy(() => import("../pages/Page404")));
